import { ProcessType } from '../../../../shared/models/process-type';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Subscription } from 'rxjs';
import { Process } from '../../../../shared/models/process';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from '../../../../shared/models/subject';
import { ProcessTypeService } from '../../../../shared/services/process-type.service';
import { ProcessService } from '../../../../shared/services/process.service';
import { SubjectService } from '../../../../shared/services/subject.service';
import { ProcessDialogComponent } from '../../../content/processes/process-dialog/process-dialog.component';
import { plural } from 'pluralize';
import {
  MessageBoxComponent,
  MessageBoxParameters,
  MessageBoxType,
} from 'app/components/messageBox/messageBox.component';
import { AuthService } from 'app/shared/services/auth.service';
import { EventService } from 'app/shared/services/event.service';
import { environment } from 'environments/environment';
import { LookupService } from 'app/shared/services/lookup.service';
import { LookupTypeService } from 'app/shared/services/lookup-type.service';

@Component({
  selector: 'process-list-widget',
  templateUrl: './process-list-widget.component.html',
  styleUrls: ['./process-list-widget.component.scss'],
  animations: fuseAnimations,
})
export class ProcessListWidgetComponent implements OnInit, OnDestroy {
  // data is an array of the process records linked to this subject
  _data = [];
  selected = [];
  columns = [];
  _processType: ProcessType;
  _selected: any;
  allowAdd = false;
  allowEdit = false;
  userReadOnly = false;
  admin = false;
  //isProcessOutcome = false;

  PartnerOrganisationName: string = 'Partner Organisation';

  @Input() set data(val: any[]) {
    this._data = [...val];
  }

  _subject: Subject;
  _processTypeId: number;

  @Input() set subject(val: Subject) {
    this.getProcessesForSubject(val);
  }
  @Input() set processTypeId(val: number) {
    this.processTypeService.getById(val).subscribe((p) => {      
      if (p){
        this._processType = p;     
        if (this._processType.name.toLowerCase() === 'time record') {
          this.onProcessesChanged = this.eventService.onUpdateTimeRecord.subscribe(() => {
            if (this._subject) {
              this.getProcessesForSubject(this._subject);
            }
          });
        } 
      }
    });
    this.getProcessesForSubject(this._subject, val);
  }

  //add inputs to remove errors.
  @Input() id: Number;
  @Input() subjectId: Number;
  @Input() processType: ProcessType;

  @Input() title = '';
  @Input() editable = false;
  @Input() titleBackgroundColor: string;
  @Input() allowDelete = true;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  private onSubjectsChanged: Subscription;
  private onProcessesChanged: Subscription;
  preventSingleClick = true;
  lastClick: Date;

  constructor(
    private processService: ProcessService,
    private subjectService: SubjectService,
    private processTypeService: ProcessTypeService,
    private authService: AuthService,
    private eventService: EventService,
    public dialog: MatDialog,
    private lookupService: LookupService,
    private lookupTypeService: LookupTypeService
  ) {
    this.onSubjectsChanged = this.subjectService.onChanged.subscribe((_) => {
      if (this._subject) {
        this.getProcessesForSubject(this._subject);
      }
    });

    this.userReadOnly = this.authService.isUserReadOnly();
    this.admin = this.authService.hasPriv('admin');
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.onSubjectsChanged?.unsubscribe();
    this.onProcessesChanged?.unsubscribe();
  }

  select(row) {
    this._selected = row;

    // javascript can't handle click and dblick click events on the same element, so have to simulate the double click and call the edit popup if we think it's a double click
    if (!this.lastClick) {
      this.lastClick = new Date();
    } else {
      const thisClick = new Date();
      const dif = (thisClick.getTime() - this.lastClick.getTime()) / 1000;
      this.lastClick = new Date();

      if (dif < 0.25) {
        this.edit(row);
      }
    }
    // console.log('selected');
  }

  // checkAllowAdd(subject) {
  //   if (subject) {
  //     if (this.isProcessOutcome) {
  //       this.allowAdd =
  //         subject &&
  //         subject.isPrimary &&
  //         !environment.limitAccessToSubjectsByOrg;
  //     } else {
  //       this.allowAdd = subject && subject.isPrimary;
  //     }
  //   }
  // }

  add() {
    //if (this.allowAdd) {
    const process = new Process();
    process.processTypeId = this._processTypeId;
    process.subjectId = this._subject.id;

    // Add default values for time records
    if (this._processType.name.toLowerCase() == 'time record') {
      if (
        this._subject &&
        this._subject.subjectUsers &&
        this._subject.subjectUsers.length > 0
      ) {
        process.addData(
          this._processType,
          'User',
          this._subject.subjectUsers[0].user.id
        );
        process.addDisplayValue(
          this._processType,
          'User',
          this._subject.subjectUsers[0].user.fullName
        );
      }

      process.addDefaultOrganisation(
        this._subject,
        this._processType,
        this.lookupService,
        this.lookupTypeService
      );
    }
    this.showDialog(process);
    // }
  }

  edit(row?) {
    row = row || this._selected;
    const process = this._data.find((x) => x.id === row.id);
    this.showDialog(process.process);
  }

  showDialog(process: Process) {
    const dialog = this.dialog.open(ProcessDialogComponent, {
      data: process,
    });

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        setTimeout(() => {
          this.getProcessesForSubject();
        }, 500);
      }
    });
  }

  unLink(row) {
    row = row || this._selected;
    const proc = row.process;
    const info = new MessageBoxParameters(
      'Are you sure you want to remove this link?',
      'Confirm',
      MessageBoxType.Confirm,
      true
    );
    this.dialog
      .open(MessageBoxComponent, {
        data: info,
        disableClose: false,
        autoFocus: false,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result === 'confirm') {
          proc.subjectId = null;
          proc.subject = null;
          this.processService.onAfterSave.subscribe((_) => {
            this.getProcessesForSubject(this._subject, this._processTypeId);
          });
          this.processService.save(proc);
        }
      });
  }

  updateTitleAndColor(processType: ProcessType) {
    if (processType) {
      // update the title bar color
      this.titleBackgroundColor = processType.color || '#0277bd';
      // update the title
      this.title = plural(processType.name);
    }
  }

  getProcessesForSubject(subject?: Subject, processTypeId?: number) {    
    subject = subject || this._subject;
    if (subject) {
      this._subject = subject;
    }
    processTypeId = processTypeId || this._processTypeId;
    if (processTypeId) {
      this._processTypeId = processTypeId;
    }
    if (this._processTypeId) {
      this.allowEdit = this._subject && this._subject.uid && !this._subject.archived && !this.userReadOnly;
      
      this.processTypeService
        .getById(processTypeId)
        .subscribe((processType) => {          
          if (processType && processType.id) {

            if (processType.isCheckList===true)
              this.allowEdit=false;

            // update the title bar color and title if necessary
            this.updateTitleAndColor(processType);

            const processes = [];
            processType = new ProcessType(processType);
            const limitOutcome = (environment.limitAccessToSubjectsByOrg === true) && (processType.name.toLowerCase() === 'outcome');
            this.allowAdd = !limitOutcome; 
            this.allowDelete = (!processType.locked || this.admin) && (!limitOutcome);
            if (subject && processType){
              this.processService
                .getSubjectProcesses(subject, processType)
                .subscribe((data) => {
                  data.forEach((process) => {
                    process = new Process(process);                    
                    processes.push({
                      id: process.id,
                      uid: process.uid,
                      title:
                        process.getSummary(processType, true) ||
                        processType.name + ' ' + process.id.toString(),
                      secondary: (processType.isCheckList===true?"Completed on "+ this.formatDateTime(process.dateTimeCompleted):""),
                      processType,
                      process,
                    });
                  });
                  this.data = processes.sort((a, b) => b.id - a.id);
                });
              }
          }
        });
    }
  }
  
  formatDateTime(dateToFormat: Date) {
    const date = new Date(dateToFormat);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const formattedDateAndTime: string = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDateAndTime;
  }
}
